import React from 'react';
import { NavyPink } from './NavyPink';
import { PinkNavy } from './PinkNavy';
import { NavyLightPink } from './NavyLightPink';

var LOGO_VARIANTS = {
    NavyPink: NavyPink, PinkNavy: PinkNavy, NavyLightPink: NavyLightPink
};

export var getLogoVariant = function getLogoVariant(variantName) {
    var LogoItem = LOGO_VARIANTS[variantName];
    return LogoItem ? React.createElement(LogoItem, null) : null;
};